const API_URL = import.meta.env.VITE_API_URL;

const MAX_IMAGE_SIZE = 10 * 1024 * 1024;

export {
  API_URL,
  MAX_IMAGE_SIZE,
};